import { Spinner } from "flowbite-react";
import { useIsSubmitting } from "remix-validated-form";

interface DashSubmitButtonProps {
  text?: string;
  loadingText?: string;
  tabIndex?: number;
}

const DashSubmitButton = ({
  text = "Save",
  loadingText = "Saving...",
  tabIndex,
}: DashSubmitButtonProps) => {
  const isSubmitting = useIsSubmitting();
  return (
    <button
      data-testid="save_homeowner"
      type="submit"
      disabled={isSubmitting}
      tabIndex={tabIndex}
      className={`flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-purple px-6 py-3 text-sm font-medium capitalize tracking-wide text-white transition-colors duration-300 hover:bg-charcoal focus:outline-blue-400 focus:ring focus:ring-gray-300 focus:ring-opacity-50`}
    >
      {isSubmitting ? (
        <>
          <Spinner
            aria-label="sign in"
            className="size-4 fill-white text-purple"
          />
          <span>{loadingText}</span>
        </>
      ) : (
        text
      )}
    </button>
  );
};

export default DashSubmitButton;
